import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    defaultLoadingContainer: {
      flex: 1,
      height: '100%',
      width: '100%',
      background: '#F1F2F5',
    },
    boxLoadingContainer: {
      flex: 1,
      background: '#F1F2F5',
      borderRadius: 6,
    },
  }),
)
